<template>
  <div class="layout-template-bubble"
       @click.stop="toggleVisible">
    <DataGridBubble :visible.sync="visible"
                    v-bind="$attrs"
                    v-on="$listeners">
      <slot name="content"
            :visible="visible"
            :hide-popover="hidePopover"></slot>
      <template slot="reference">
        <slot :toggle-visible="toggleVisible"></slot>
      </template>
    </DataGridBubble>
  </div>
</template>

<script>
import DataGridBubble from './grid/DataGridBubble'
export default {
  name: 'TemplateBubble',
  components: {
    DataGridBubble
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible
    },
    hidePopover () {
      this.visible = false
    }
  }
}
</script>

<style lang="scss">
  .layout-template-bubble {
    display: inline-block;
  }
</style>
